import { Hubble } from '@seek/hubble';
import type { HubbleOptions } from '@seek/hubble/lib/HubbleOptions';
import { getClientSolId } from '@seek/sol-id';

import {
  APP_NAME,
  APP_VERSION,
  BRAND,
  COUNTRY,
} from 'src/app/shared/constants/configObjectProperties';
import { getConfig } from 'src/app/utils/config';
import { isProd, isServerRendering } from 'src/app/utils/environment';
import { log } from 'src/app/utils/logging';

const isProdEnv = isProd();

const getVisitorId = () => {
  try {
    return getClientSolId();
  } catch (error) {
    log.error('Hubble | Error getting visitor id while initiating', { error });
    return '';
  }
};

const visitorId = !isServerRendering() ? getVisitorId() : '';

const hubbleOptions: HubbleOptions = {
  appName: getConfig(APP_NAME),
  appVersion: getConfig(APP_VERSION),
  brand: getConfig(BRAND),
  country: getConfig(COUNTRY),
  disabled: !Boolean(visitorId),
  experience: 'hirer',
  isProduction: isProdEnv,
};

let hubble: Hubble;

if (!isServerRendering()) {
  hubble = new Hubble(hubbleOptions, visitorId);

  if (!isProdEnv) {
    log.trace('Hubble | Initialised', { hubbleOptions });

    hubble.on('queue', (event) => {
      log.trace('Hubble | Event Queued', { event });
    });

    hubble.on('send', (events) => {
      log.trace('Hubble | Send', { events });
    });

    hubble.on('success', (events) => {
      log.trace('Hubble | Success', { events });
    });

    hubble.on('idle', () => {
      log.trace('Hubble | Finished (Idle)');
    });
  }
}

export { hubble };
